<template>
  <textarea
    v-model="model"
    v-focus="hasFocus"
  ></textarea>
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';

export default {
  mixins: [focusable],

  props: {
    value: String
  },

  computed: {
    model: {
      get: ({ value }) => value,

      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>
